import React from "react";

const NotFound = () => (
  <div className="container">
    <h1 className="text-center">File Not Found</h1>
    <p className="text-center">
      The page you are looking for doesn&rsquo;t seem to exist.
    </p>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js